<template>
  <div>
    <a-divider />
    <a-card :bordered="false">
      <a-row type="flex" justify="space-between">
        <a-col :span="10">
          <div class="login-wrap">
            <Alteration/>
          </div>
        </a-col>
        <a-col :span="13">
          <img
            style="width:100%"
            class="cover"
            v-if="tenantInfo.loginBg"
            :src="tenantInfo.qiniuDomain + '/' + tenantInfo.loginBg"
            alt=""
          />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Alteration from '../components/user/Alteration'
export default {
  components:{
    Alteration
  },
  data() {
    return {
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.login-wrap{
  padding: 10px 40px;
}
</style>